module.exports = __webpack_public_path__ + "img/20210430_111315.ade314e0.jpg";